// invoice-management-frontend/src/services/settingsService.ts
import apiService from './api';

export interface CompanyInfo {
  name: string;
  address: string;
  email: string;
  phone: string;
  website: string;
  logo: string;
}

const settingsService = {
  async getCompanyInfo(): Promise<CompanyInfo> {
    const response = await apiService.get<CompanyInfo>('/settings/company');
    return response.data;
  },
 async getCompanyPublicInfo(id: number): Promise<CompanyInfo> {
    const response = await apiService.get<CompanyInfo>('/get-settings/company?company_id='+id);
    return response.data;
  },
  async updateCompanyInfo(data: CompanyInfo): Promise<CompanyInfo> {
    const response = await apiService.put<CompanyInfo>('/settings/company', data);
    console.log("response::::::", response)
    return response.data;
  },
  async uploadLogo(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await apiService.post<{ filename: string }>('/upload/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data.filename; // e.g., "assets/images/company-logo.png"
  },

  // TFA APIs
  async getTfaStatus(): Promise<{ enabled: boolean }> {
    const response = await apiService.get<{ enabled: boolean }>('/settings/tfa/status');
    console.log("response::::::::", response.data)
    return response.data;
  },
  async enableTfa(pin: string, confirmPin: string): Promise<{ message: string }> {
    const response = await apiService.post<{ message: string }>('/settings/tfa/enable', { pin, confirmPin });
    return response.data;
  },
  async disableTfa(pin: string): Promise<{ message: string }> {
    const response = await apiService.post<{ message: string }>('/settings/tfa/disable', { pin });
    return response.data;
  },
  async verifyTfa(pin: string): Promise<{ message: string }> {
    const response = await apiService.post<{ message: string }>('/settings/tfa/verify', { pin });
    return response.data;
  }
};

export default settingsService;
